export const pageConfig = [
  {
    name: 'isPageRandomized:switch',
    category: 'Randomization',
    default: false,
    isSerializable: true,
  },
  {
    name: 'randomizationGroup',
    dependsOn: 'isPageRandomized',
    category: 'Randomization',
    visibleIf: (obj: any) => obj.isPageRandomized === true,
    choices: [
      { text: 'Group A', value: 'A' },
      { text: 'Group B', value: 'B' },
      { text: 'Group C', value: 'C' },
      { text: 'Group D', value: 'D' },
      { text: 'Group E', value: 'E' },
    ],
    isSerializable: true,
  },
  {
    name: 'isTemplatePage:switch',
    category: 'Template',
    default: false,
    isSerializable: true,
  },
  {
    name: 'isRandomizedContext:switch',
    dependsOn: 'isTemplatePage',
    category: 'Template',
    visibleIf: (obj: any) => obj.isTemplatePage === true,
    isSerializable: true,
  },
  {
    name: 'templateContext:string',
    dependsOn: 'isTemplatePage',
    category: 'Template',
    visibleIf: (obj: any) => obj.isTemplatePage === true,
    isSerializable: true,
  },
];
